import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import getSourceDataById from "@app/services/cases/getSourceDataById";
import getEmailsBySourceDataId from "@app/services/cases/getEmailsBySourceDataId";

import { useToast } from "@hooks/useToast";

import { useDataSourceDetailsContext } from "../providers";

export const useDataSourceDetailsLoader = () => {
  const { setDataSourceDetails, setEmailMessages } =
    useDataSourceDetailsContext();
  const { messages } = useIntl();
  const { data_source_id } = useParams();
  const { showErrorToast } = useToast();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchDataSourceDetails = async () => {
      setIsLoading(true);

      try {
        const [
          {
            data: [sourceData],
          },
          { data: emails },
        ] = await Promise.all([
          getSourceDataById(data_source_id, {
            signal: controller.signal,
          }),
          getEmailsBySourceDataId(data_source_id, {
            signal: controller.signal,
          }),
        ]);

        setDataSourceDetails(sourceData);
        setEmailMessages(emails);
      } catch {
        showErrorToast(messages.exception_error_message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDataSourceDetails();

    return () => {
      controller.abort();
    };
  }, [
    data_source_id,
    setDataSourceDetails,
    showErrorToast,
    messages,
    setEmailMessages,
  ]);

  return {
    isLoading,
  };
};
